module.exports = {"enabled":true,"id":"webinars-2016-10-20","icon":"information","dateExpires":"2016-10-20T16:00:00Z","locale":"en-US","message":"Upcoming Webinar: [Roadmaps and Retrospectives](https://trello.com/webinars)."}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/data/boards-page-announcement.json
// module id = hdJ/
// module chunks = 0